import { agent } from '@shared/services/agent';
import { ReportConfig, ReportType } from '@shared/models/report.models';

export async function getReportConfigs(): Promise<ReportConfig[]> {
    return await agent.requests.get('/api/report-configs');
}

export async function updateReportConfig(config: ReportConfig): Promise<void> {
    return await agent.requests.post('/api/report-config', config);
}

export async function sendSampleReport(reportType: ReportType): Promise<void> {
    return await agent.requests.post('/api/report-sample', { reportType });
}
